/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseIEnumerable1OSICoreModelsDbOsiPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbRegistrationPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsDbUserPrivateCoreLib,
  ApiResponseIEnumerable1OSICoreModelsResponsesUserAffiliationPrivateCoreLib,
  ApiResponseResponsesUserResponseOSICoreTypes,
  PostApiUsersIdClearAllInformationParams,
  RequestsChangePasswordRequest,
  RequestsResetPasswordRequest,
  RequestsUserRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить данные пользователя по токену
 */
export const getApiUsers = (options?: SecondParameter<typeof axiosForReactQueryInstance>, signal?: AbortSignal) => {
  return axiosForReactQueryInstance<ApiResponseResponsesUserResponseOSICoreTypes>(
    { url: `/api/Users`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersQueryKey = () => {
  return [`/api/Users`] as const;
};

export const getGetApiUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsers>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData>>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsers>>> = ({ signal }) =>
    getApiUsers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsers>>>;
export type GetApiUsersQueryError = ErrorType<unknown>;

export function useGetApiUsers<TData = Awaited<ReturnType<typeof getApiUsers>>, TError = ErrorType<unknown>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsers<TData = Awaited<ReturnType<typeof getApiUsers>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsers<TData = Awaited<ReturnType<typeof getApiUsers>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить данные пользователя по токену
 */

export function useGetApiUsers<TData = Awaited<ReturnType<typeof getApiUsers>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить данные пользователя по Id
 */
export const getApiUsersId = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesUserResponseOSICoreTypes>(
    { url: `/api/Users/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersIdQueryKey = (id: number) => {
  return [`/api/Users/${id}`] as const;
};

export const getGetApiUsersIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersId>>> = ({ signal }) =>
    getApiUsersId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersId>>>;
export type GetApiUsersIdQueryError = ErrorType<unknown>;

export function useGetApiUsersId<TData = Awaited<ReturnType<typeof getApiUsersId>>, TError = ErrorType<unknown>>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersId>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersId<TData = Awaited<ReturnType<typeof getApiUsersId>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersId>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersId<TData = Awaited<ReturnType<typeof getApiUsersId>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить данные пользователя по Id
 */

export function useGetApiUsersId<TData = Awaited<ReturnType<typeof getApiUsersId>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Изменение данных пользователя
 */
export const putApiUsersId = (
  id: number,
  requestsUserRequest: BodyType<RequestsUserRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Users/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsUserRequest
    },
    options
  );
};

export const getPutApiUsersIdMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUsersId>>,
    TError,
    { id: number; data: BodyType<RequestsUserRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUsersId>>,
  TError,
  { id: number; data: BodyType<RequestsUserRequest> },
  TContext
> => {
  const mutationKey = ['putApiUsersId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUsersId>>,
    { id: number; data: BodyType<RequestsUserRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiUsersId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUsersId>>>;
export type PutApiUsersIdMutationBody = BodyType<RequestsUserRequest>;
export type PutApiUsersIdMutationError = ErrorType<unknown>;

/**
 * @summary Изменение данных пользователя
 */
export const usePutApiUsersId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUsersId>>,
      TError,
      { id: number; data: BodyType<RequestsUserRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUsersId>>,
  TError,
  { id: number; data: BodyType<RequestsUserRequest> },
  TContext
> => {
  const mutationOptions = getPutApiUsersIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получить данные пользователя по коду (он же телефон)
 */
export const getApiUsersCode = (
  code: string,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesUserResponseOSICoreTypes>(
    { url: `/api/Users/${code}`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersCodeQueryKey = (code: string) => {
  return [`/api/Users/${code}`] as const;
};

export const getGetApiUsersCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersCode>>,
  TError = ErrorType<unknown>
>(
  code: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCode>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersCodeQueryKey(code);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersCode>>> = ({ signal }) =>
    getApiUsersCode(code, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!code, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersCode>>>;
export type GetApiUsersCodeQueryError = ErrorType<unknown>;

export function useGetApiUsersCode<TData = Awaited<ReturnType<typeof getApiUsersCode>>, TError = ErrorType<unknown>>(
  code: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCode>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCode>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersCode<TData = Awaited<ReturnType<typeof getApiUsersCode>>, TError = ErrorType<unknown>>(
  code: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCode>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersCode>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersCode<TData = Awaited<ReturnType<typeof getApiUsersCode>>, TError = ErrorType<unknown>>(
  code: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCode>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить данные пользователя по коду (он же телефон)
 */

export function useGetApiUsersCode<TData = Awaited<ReturnType<typeof getApiUsersCode>>, TError = ErrorType<unknown>>(
  code: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersCode>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersCodeQueryOptions(code, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить все заявки пользователя
 */
export const getApiUsersIdRegistrations = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbRegistrationPrivateCoreLib>(
    { url: `/api/Users/${id}/registrations`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersIdRegistrationsQueryKey = (id: number) => {
  return [`/api/Users/${id}/registrations`] as const;
};

export const getGetApiUsersIdRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdRegistrations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersIdRegistrationsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersIdRegistrations>>> = ({ signal }) =>
    getApiUsersIdRegistrations(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersIdRegistrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersIdRegistrations>>>;
export type GetApiUsersIdRegistrationsQueryError = ErrorType<unknown>;

export function useGetApiUsersIdRegistrations<
  TData = Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdRegistrations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersIdRegistrations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersIdRegistrations<
  TData = Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdRegistrations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersIdRegistrations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersIdRegistrations<
  TData = Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdRegistrations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить все заявки пользователя
 */

export function useGetApiUsersIdRegistrations<
  TData = Awaited<ReturnType<typeof getApiUsersIdRegistrations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdRegistrations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersIdRegistrationsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить все активные ОСИ пользователя
 */
export const getApiUsersIdOsi = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbOsiPrivateCoreLib>(
    { url: `/api/Users/${id}/osi`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersIdOsiQueryKey = (id: number) => {
  return [`/api/Users/${id}/osi`] as const;
};

export const getGetApiUsersIdOsiQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersIdOsi>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersIdOsiQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersIdOsi>>> = ({ signal }) =>
    getApiUsersIdOsi(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersIdOsi>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersIdOsiQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersIdOsi>>>;
export type GetApiUsersIdOsiQueryError = ErrorType<unknown>;

export function useGetApiUsersIdOsi<TData = Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError = ErrorType<unknown>>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersIdOsi>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersIdOsi>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersIdOsi<TData = Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersIdOsi>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersIdOsi>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersIdOsi<TData = Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить все активные ОСИ пользователя
 */

export function useGetApiUsersIdOsi<TData = Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError = ErrorType<unknown>>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdOsi>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersIdOsiQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Изменение пароля пользователя
 */
export const putApiUsersIdChangePassword = (
  id: number,
  requestsChangePasswordRequest: BodyType<RequestsChangePasswordRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Users/${id}/change-password`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsChangePasswordRequest
    },
    options
  );
};

export const getPutApiUsersIdChangePasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUsersIdChangePassword>>,
    TError,
    { id: number; data: BodyType<RequestsChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUsersIdChangePassword>>,
  TError,
  { id: number; data: BodyType<RequestsChangePasswordRequest> },
  TContext
> => {
  const mutationKey = ['putApiUsersIdChangePassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUsersIdChangePassword>>,
    { id: number; data: BodyType<RequestsChangePasswordRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiUsersIdChangePassword(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUsersIdChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUsersIdChangePassword>>
>;
export type PutApiUsersIdChangePasswordMutationBody = BodyType<RequestsChangePasswordRequest>;
export type PutApiUsersIdChangePasswordMutationError = ErrorType<unknown>;

/**
 * @summary Изменение пароля пользователя
 */
export const usePutApiUsersIdChangePassword = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUsersIdChangePassword>>,
      TError,
      { id: number; data: BodyType<RequestsChangePasswordRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUsersIdChangePassword>>,
  TError,
  { id: number; data: BodyType<RequestsChangePasswordRequest> },
  TContext
> => {
  const mutationOptions = getPutApiUsersIdChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Изменение пароля пользователя по ОТП
 */
export const putApiUsersIdResetPassword = (
  id: number,
  requestsResetPasswordRequest: BodyType<RequestsResetPasswordRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Users/${id}/reset-password`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsResetPasswordRequest
    },
    options
  );
};

export const getPutApiUsersIdResetPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUsersIdResetPassword>>,
    TError,
    { id: number; data: BodyType<RequestsResetPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUsersIdResetPassword>>,
  TError,
  { id: number; data: BodyType<RequestsResetPasswordRequest> },
  TContext
> => {
  const mutationKey = ['putApiUsersIdResetPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUsersIdResetPassword>>,
    { id: number; data: BodyType<RequestsResetPasswordRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiUsersIdResetPassword(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUsersIdResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUsersIdResetPassword>>
>;
export type PutApiUsersIdResetPasswordMutationBody = BodyType<RequestsResetPasswordRequest>;
export type PutApiUsersIdResetPasswordMutationError = ErrorType<unknown>;

/**
 * @summary Изменение пароля пользователя по ОТП
 */
export const usePutApiUsersIdResetPassword = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUsersIdResetPassword>>,
      TError,
      { id: number; data: BodyType<RequestsResetPasswordRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUsersIdResetPassword>>,
  TError,
  { id: number; data: BodyType<RequestsResetPasswordRequest> },
  TContext
> => {
  const mutationOptions = getPutApiUsersIdResetPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Установить постоянный пароль для пользователя
 */
export const putApiUsersIdSetPassword = (
  id: number,
  putApiUsersIdSetPasswordBody: BodyType<string>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/Users/${id}/set-password`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putApiUsersIdSetPasswordBody
    },
    options
  );
};

export const getPutApiUsersIdSetPasswordMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUsersIdSetPassword>>,
    TError,
    { id: number; data: BodyType<string> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUsersIdSetPassword>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationKey = ['putApiUsersIdSetPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUsersIdSetPassword>>,
    { id: number; data: BodyType<string> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiUsersIdSetPassword(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUsersIdSetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUsersIdSetPassword>>>;
export type PutApiUsersIdSetPasswordMutationBody = BodyType<string>;
export type PutApiUsersIdSetPasswordMutationError = ErrorType<unknown>;

/**
 * @summary Установить постоянный пароль для пользователя
 */
export const usePutApiUsersIdSetPassword = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUsersIdSetPassword>>,
      TError,
      { id: number; data: BodyType<string> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUsersIdSetPassword>>,
  TError,
  { id: number; data: BodyType<string> },
  TContext
> => {
  const mutationOptions = getPutApiUsersIdSetPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Удаление всей информации по пользователю: пользователь, контакты, заявки, ОСИ, услуги, абоненты, планы и пр.
 */
export const postApiUsersIdClearAllInformation = (
  id: number,
  params: PostApiUsersIdClearAllInformationParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Users/${id}/clear-all-information`, method: 'POST', params, signal },
    options
  );
};

export const getPostApiUsersIdClearAllInformationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUsersIdClearAllInformation>>,
    TError,
    { id: number; params: PostApiUsersIdClearAllInformationParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUsersIdClearAllInformation>>,
  TError,
  { id: number; params: PostApiUsersIdClearAllInformationParams },
  TContext
> => {
  const mutationKey = ['postApiUsersIdClearAllInformation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUsersIdClearAllInformation>>,
    { id: number; params: PostApiUsersIdClearAllInformationParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return postApiUsersIdClearAllInformation(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUsersIdClearAllInformationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUsersIdClearAllInformation>>
>;

export type PostApiUsersIdClearAllInformationMutationError = ErrorType<unknown>;

/**
 * @summary Удаление всей информации по пользователю: пользователь, контакты, заявки, ОСИ, услуги, абоненты, планы и пр.
 */
export const usePostApiUsersIdClearAllInformation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUsersIdClearAllInformation>>,
      TError,
      { id: number; params: PostApiUsersIdClearAllInformationParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUsersIdClearAllInformation>>,
  TError,
  { id: number; params: PostApiUsersIdClearAllInformationParams },
  TContext
> => {
  const mutationOptions = getPostApiUsersIdClearAllInformationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Получение привязанных помещений пользователя по его номеру телефона
 */
export const getApiUsersIdAffiliations = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsResponsesUserAffiliationPrivateCoreLib>(
    { url: `/api/Users/${id}/affiliations`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersIdAffiliationsQueryKey = (id: number) => {
  return [`/api/Users/${id}/affiliations`] as const;
};

export const getGetApiUsersIdAffiliationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdAffiliations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersIdAffiliationsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersIdAffiliations>>> = ({ signal }) =>
    getApiUsersIdAffiliations(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersIdAffiliationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersIdAffiliations>>>;
export type GetApiUsersIdAffiliationsQueryError = ErrorType<unknown>;

export function useGetApiUsersIdAffiliations<
  TData = Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdAffiliations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersIdAffiliations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersIdAffiliations<
  TData = Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdAffiliations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersIdAffiliations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersIdAffiliations<
  TData = Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdAffiliations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получение привязанных помещений пользователя по его номеру телефона
 */

export function useGetApiUsersIdAffiliations<
  TData = Awaited<ReturnType<typeof getApiUsersIdAffiliations>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersIdAffiliations>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersIdAffiliationsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Список активных председателей
 */
export const getApiUsersActiveChairmans = (
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsDbUserPrivateCoreLib>(
    { url: `/api/Users/active-chairmans`, method: 'GET', signal },
    options
  );
};

export const getGetApiUsersActiveChairmansQueryKey = () => {
  return [`/api/Users/active-chairmans`] as const;
};

export const getGetApiUsersActiveChairmansQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersActiveChairmans>>, TError, TData>>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUsersActiveChairmansQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersActiveChairmans>>> = ({ signal }) =>
    getApiUsersActiveChairmans(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUsersActiveChairmansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersActiveChairmans>>>;
export type GetApiUsersActiveChairmansQueryError = ErrorType<unknown>;

export function useGetApiUsersActiveChairmans<
  TData = Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersActiveChairmans>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersActiveChairmans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersActiveChairmans<
  TData = Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersActiveChairmans>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
          TError,
          Awaited<ReturnType<typeof getApiUsersActiveChairmans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUsersActiveChairmans<
  TData = Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersActiveChairmans>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Список активных председателей
 */

export function useGetApiUsersActiveChairmans<
  TData = Awaited<ReturnType<typeof getApiUsersActiveChairmans>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUsersActiveChairmans>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUsersActiveChairmansQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
